module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wizard"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.setSceneOrigin()
      }
    }
  }, [_c('div', {
    staticClass: "data left",
    class: {
      active: _vm.ifo, disabled: _vm.ifo
    }
  }, [_c('div', {
    staticClass: "step"
  }, [(_vm.origin) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n            Step 1\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Origin")]), _vm._v(" "), (_vm.origin) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose origin")])]), _vm._v(" "), (_vm.ifo) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.ifo) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()]), _c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.sceneDestination()
      }
    }
  }, [_c('div', {
    staticClass: "data",
    class: {
      active: _vm.ifd, disabled: _vm.ifd || !_vm.origin
    }
  }, [_c('div', {
    staticClass: "step"
  }, [(_vm.destination) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n            Step 2\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Destination")]), _vm._v(" "), (_vm.destination) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.destination.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose destination")])]), _vm._v(" "), (_vm.ifd) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.ifd) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()]), _c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.sceneFlight()
      }
    }
  }, [_c('div', {
    staticClass: "data right",
    class: {
      active: _vm.iff, disabled: _vm.iff || !_vm.origin || !_vm.destination
    }
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Flight")]), _vm._v(" "), (_vm.flight) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.flight.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose flight")])]), _vm._v(" "), (_vm.iff) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.iff) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [(_vm.ifo) ? _c('origins') : _vm._e(), _vm._v(" "), (_vm.ifd) ? _c('destinations') : _vm._e(), _vm._v(" "), (_vm.iff) ? _c('flights') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_c('p', [_vm._v("Want to go somewhere but don't know exactly where?")]), _vm._v(" "), _c('p', [_vm._v("Follow the steps below to figure out where!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b7f1adc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizard.vue
// module id = 69
// module chunks = 1